import React from 'react';
import './style.css';
import Utils from "../../utils/utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye} from "@fortawesome/free-solid-svg-icons";
import UserController from "../../services/system/user/user-controller";
import {toast} from "react-toastify";
const eye = <FontAwesomeIcon icon={faEye} />;
class DeleteAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      anyValue: '',
      username: '',
      password: '',
      showPassword: false,
      remember: false,
      showForgotPassword: false,
    };
  }
  onDeleteAccount = (e) => {
    if (!this.state.remember){
      toast.error("Vui lòng chọn đồng ý xóa tài khoản!")
    }else {
      let payload = {
        username: this.state.username,
        password: this.state.password
      };
      UserController.deleteAccount(payload, res => {
        if (!res.success) {
          toast.error("Yêu cầu không thành công")
        } else {
          toast.success("Xóa tài khoản thành công!")
        }
      }).catch((error) => {
        toast.error("Yêu cầu không thành công")
      })
    }
  };
  render() {
    const togglePasswordVisiblity = () => {
      this.setState({showPassword: !this.state.showPassword});
    };
    return (
      <div className='about-us-wrapper'>
        <div className='banner container text-center'>
          <div>
            <div className="limiter">
              <div className="container-login100" style={{backgroundImage: 'url("images/bg_times.png")'}}>
                <div className="wrap-login100">
                  <div className="login100-form validate-form">
                    <span className="login100-form-logo">
                      <div className='justify-center img-logo-wrapper' style={{width:"72%", height: "100%", textAlign: 'center', backgroundImage: `url("/images/logo_sas.png")`}} />
                    </span>
                    <span className="login100-form-title p-b-34 p-t-27">
                      Yêu cầu xóa tài khoản
                    </span>
                    <span className="label-del">
                          Nhập tài khoản bạn muốn xóa dữ liệu!
                    </span>
                    <div className="wrap-input100 validate-input" data-validate="Tên đăng nhập">
                      <input
                          placeholder="Tên đăng nhập"
                          maxLength={255}
                          type="text"
                          className="input100"
                          value={this.state.username}
                          onChange={e => this.setState({username: Utils.filterNormalCharacter(e.target.value).trim()})}
                      />
                      {/*<span className="focus-input100" data-placeholder="Tên đăng nhập"/>*/}
                    </div>
                    <div className="wrap-input100 validate-input" data-validate="Enter password">
                      <input
                          placeholder="Mật khẩu"
                          maxLength={255}
                          type={this.state.showPassword ? "text" : "password"}
                          className="input100"
                          value={this.state.password}
                          onKeyDown={event => this.keyPress(event, 'enter')}
                          onChange={e => this.setState({password: e.target.value})}
                      />
                      <i className="hidePassword" onClick={togglePasswordVisiblity}>{eye}</i>{" "}
                    </div>
                    <div className="contact100-form-checkbox">
                        <span className="label-note">
                      Lưu ý: Tài khoản đã bị xóa thì không thể khôi phục!
                    </span>
                    </div>

                    <div className="contact100-form-checkbox">
                      <input
                          type="checkbox"
                          onChange={(e) => {
                            const value = this.state.remember;
                            this.setState({remember: !value});
                          }}
                          checked={this.state.remember}
                      />
                      <label className="label-checkbox100" htmlFor="ckb1">
                        Tôi đồng ý xóa tài khoản và toàn bộ dữ liệu liên quan tới tài khoản của tôi!
                      </label>
                    </div>
                    <div className="container-login100-form-btn">
                      <button className="login100-form-btn"  onClick={this.onDeleteAccount}>
                        Xóa tài khoản
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DeleteAccount;
